/**
 * Customer-facing routes that show the animated Alegarta line background.
 * Admin, toolkit, and internal ops paths are excluded.
 */
const ALEGARTA_EXCLUDED_PREFIXES = [
    '/s/',
    '/admin',
    '/packer',
    '/productiontoolkit',
    '/odin',
    '/venues-toolkit',
    '/contactmanager',
    '/newslettereditor',
    '/printing',
    '/invoicer',
    '/delivery-centre',
    '/email-logs',
    '/email-template-studio',
    '/announcement-editor',
    '/pdf-editor',
    '/productmanagement',
    '/product-definitions',
    '/rider',
    '/staff-dashboard',
    '/staff-management',
    '/invoice-control',
    '/messages',
    '/register',
];

export function isAlegartaRoute(pathname) {
    const path = String(pathname || '/').toLowerCase();
    return !ALEGARTA_EXCLUDED_PREFIXES.some((prefix) => path.startsWith(prefix));
}
